import { SHARED_AUTH_URLS } from '../constant/actionTypes';

const getSharedAuthUrlsData = (state, action) => {
  switch (action.type) {
    case SHARED_AUTH_URLS.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case SHARED_AUTH_URLS.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SHARED_AUTH_URLS.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};

export default getSharedAuthUrlsData;
